
const firebaseConfig = {
  apiKey: "AIzaSyBYKoKiuf2N0SIFWdKPQGmp7RYT81Rl-TI",
  authDomain: "systema-nova.firebaseapp.com",
  projectId: "systema-nova",
  storageBucket: "systema-nova.appspot.com",
  messagingSenderId: "540370641352",
  appId: "1:540370641352:web:572d9390b754f609c0e0fd",
  measurementId: "G-E9CFEXJNLE"
};
export default firebaseConfig;


